export const getTemplateType = (typeString) => {
  return typeString.includes("email") ? "EMAIL" : "LANDING";
};

export const parseLanguages = (languagesString) => {
  return languagesString ? languagesString.split(",") : [];
};
